import { useEffect, useState } from 'react'
import axios from '../axios'
import { Table } from 'antd';
import getUsernamesFromUserId from '../modules/getUsernamesFromUserId';


function Players() {
    const [players, setPlayers] = useState([]);
    const [playersWithUsername, setPlayersWithUsername] = useState([]);
    const [server, setServer] = useState(() => {
        const server = localStorage.getItem('selectedServer');
        return server ? JSON.parse(server) : null;
    });
    useEffect(() => {
        axios.get(`/api/user/player/${server?.id}`)
            .then((res) => {
                setPlayers(res.data);
            })
            .catch((err) => {
                console.log(err);
                window.location.reload();
            });
    }, []);

    useEffect(() => {
        fetch();
        async function fetch() {
            var userArray = [];
            var tmpPlayers = [...players];
            if (players.length > 0) {
                for (var player of players) {
                    userArray.push(player.robloxUserId);
                }
                var usernamesData = await getUsernamesFromUserId(userArray);
                for (var _player of usernamesData) {
                    for (var player2 of tmpPlayers) {
                        if (player2.robloxUserId === _player.id) {
                            player2.username = _player.name;
                        }
                    }
                    setPlayersWithUsername(tmpPlayers);
                }

            }
        }

    }, [players])

    const columns = [
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'name',
        },
        {
            title: "Enabled",
            dataIndex: "enabled",
            key: "enabled",
            render: (text, record) => (
                record.enabled ? '✅' : '❌'
            )
        },
        {
            title: "Anonymous",
            dataIndex: "anonymous",
            key: "anonymous",
            render: (text, record) => (
                record.anonymous ? '✅' : '❌'
            )
        },

    ];
    return (
        <div className='section-2'>
            <Table className='section-2-table' dataSource={playersWithUsername} columns={columns} rowKey="id" />
        </div>
    )
}

export default Players